import { render, staticRenderFns } from "./LatestAdvertisingContract.vue?vue&type=template&id=348eb19d&"
import script from "./LatestAdvertisingContract.vue?vue&type=script&lang=js&"
export * from "./LatestAdvertisingContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports